export default __webpack_public_path__ + "static/Nox2-f7eca610c3d7515a303637472c0c3e28.png";